module.exports = __webpack_public_path__ + "assets/img/00056.65374fc3.png";